/**
 * Display labels for the document types classification assigns
 * (`DocumentType` in the backend's catalog schema), in the order the Files
 * screens list them. A type the backend adds later still renders, title-cased,
 * after these.
 */
export const DOCUMENT_TYPE_LABELS: Record<string, string> = {
	borrower_financials: "Financial statements",
	audited_financial: "Audited financials",
	deal_model: "Financial model",
	loan_agreement: "Loan agreement",
	amendment: "Amendment",
	compliance_certificate: "Compliance certificate",
	kpi_deck: "KPI deck",
	management_discussion: "Management discussion",
	ancillary_schedule: "Schedule",
	loan_tape: "Loan tape",
	other: "Other",
};

/** Files classification has not typed yet (or could not). */
export const UNTYPED_DOCUMENT_KEY = "__untyped__";

const ORDER = Object.keys(DOCUMENT_TYPE_LABELS);

export const documentTypeLabel = (key: string): string => {
	if (key === UNTYPED_DOCUMENT_KEY) return "Not sorted yet";
	return (
		DOCUMENT_TYPE_LABELS[key] ??
		key.replace(/_/g, " ").replace(/^\w/, (c) => c.toUpperCase())
	);
};

/** Known types in catalog order, then unknown ones, then "Not sorted yet". */
export const compareDocumentTypes = (a: string, b: string): number => {
	const rank = (key: string) => {
		if (key === UNTYPED_DOCUMENT_KEY) return Number.MAX_SAFE_INTEGER;
		const i = ORDER.indexOf(key);
		return i === -1 ? ORDER.length : i;
	};
	return rank(a) - rank(b) || a.localeCompare(b);
};
